/**
 * Beneficiary communities — the ones a session can serve (D19). Read-only.
 */

import type { BeneficiaryCommunity } from '@parinaam-vms/shared';
import { apiGet } from './client';

export function listCommunities(): Promise<BeneficiaryCommunity[]> {
  return apiGet<BeneficiaryCommunity[]>('/communities');
}
